__turbopack_context__.v({
  "contained": "counter-button-module-scss-module__pGe4UW__contained",
  "counter-button": "counter-button-module-scss-module__pGe4UW__counter-button",
  "disabled": "counter-button-module-scss-module__pGe4UW__disabled",
  "error": "counter-button-module-scss-module__pGe4UW__error",
  "helper-text": "counter-button-module-scss-module__pGe4UW__helper-text",
  "value": "counter-button-module-scss-module__pGe4UW__value",
});
